import addSettingApi from '@/api/addSetting/addSettingApi.js';
import {collapseInit} from '@/util/collapseScript.js';

export default {
	name: 'situation-ring',
	mixins: [],
	extends: {},
	components: {},
	props: [],
	data() {
		return {
		};
	},
	computed: {
		
	},
	watch: {
	},
	created() {},
	mounted() {
        this.init();
	},
	updated() {},
	beforeDestroy() {},
	methods: {
        async init() {
			await addSettingApi.situationRingPermissionValidation();
			collapseInit();
        }
	},
};



// WEBPACK FOOTER //
// ./src/components/addSetting/situationRing.js